<template>
    <v-container>
        <v-row>
            <v-img :src="require('@/assets/qana01.jpg')"/>
        </v-row>
        <v-row>
            <v-col align="left">
                <h1>Q&A</h1>

                <h2>Hvad er gofiqr?</h2>
                <p>QR-koder er den hurtigste og mest præcise måde at hente information til en smartphone på. Med gofiqr får I adgang til et meget brugervenligt værktøj, der kan styre QR-koder på en professionel måde - uden behov for IT-folk og programmører.</p>

                <h2>Hvad kan jeg bruge gofiqr til?</h2>
                <p>At gøre dokumentation og information mobilvenligt og elektronisk. Brug gofiqr til at spare mange penge på produktion og vedligeholdelse af produktdokumentation, til at sikre bedre videndeling i organisationen og til effektiv profilering.</p>

                <h2>Hvordan fungerer gofiqr?</h2>
                <p>En bruger/kunde med en smartphone scanner jeres QR-koder og bliver præsenteret for en professionelt udseende liste af valgmuligheder til at få mere information. Brugeren ser jeres visuelle identitet og kan læse om produkter, se videofilm om produkter, blive inspireret og få dagens gode tilbud. I styrer det hele fra gofiqr cloudløsningen, der tilgås af virksomhedens fagpersonale. Med gofiqr skal I ikke udskifte koderne – kun det indhold en bruger med en smartphone præsenteres for.</p>

                <h2>Hvilke typer informationer og medier kan jeg lægge ind?</h2>
                <p>Alt, som du kan se i en internet-browser bliver præsenteret flot på en vilkårlig smartphone (iOS, Android, Windows). Dokumenter, film, billeder, lydklip og hjemmesider kan let lægges ind.</p>

                <h2>Hvem bestemmer indholdet på min gofiqr-side?</h2>
                <p>Du opretter nye koder til din organisation, og på dem har du 100% kontrol over, hvad der skal vises, når en bruger scanner koden. Du bestemmer selv, om der skal være logoer, konkurrencer, reklamer eller anden profilering, og du kan med én kode henvende dig til brugere på mange sprog.</p>

                <h2>Er mine gofiqr-data sikre?</h2>
                <p>Ja, og vi kan hjælpe dig med, at sikre, at det indhold du lægger ind i gofiqr også opbevares sikkert. Sikker og pålidelig visning af oplysninger på mobile enheder er vores adelsmærke.</p>

                <h2>Kan I anbefale en reklamefri scanner til min telefon?</h2>
                <p>Ja, QR-scanneren er vigtig – de fleste gratis apps, der kan scanne QR-koder vil vise reklamer fra tid til anden. Derfor anbefaler vi disse scannerløsninger, der  duer reklamefrit og pålideligt: iOS,  Android, Windows.</p>

                <h2>Hvor adskiller gofiqr sig fra en almindelig QR-kode?</h2>
                <p>En gofiqr kode skal aldrig udskiftes. Du kan trygt sætte koden på produkter og materialer uden at bekymre dig om, at de udløber. Vi tænker: Koden først og det dynamiske indhold bagefter. gofiqr koder er dine koder – man kan aflæse din organisations navn i koderne. Og til forskel fra en vilkårlig kodegenerator, du kan finde på nettet, er en gofiqr kode altid fri for virus.</p>

                <h2>Hvor tit kan jeg lægge nye data ind på min gofiqr?</h2>
                <p>Det er helt dynamisk, og det går lynhurtigt. Hvis du har oplysninger, der udskiftes hver time eller hvert minut, er det ikke et problem. Vi har lavet gofiqr til at passe ind i en dynamisk hverdag – uden du skal være IT-programmør.</p>

                <h2>Hvem kan tilgå data på gofiqr?</h2>
                <p>Kun dig selv og de brugere du inviterer – du har fuld kontrol.</p>

                <h2>Kan jeg aflæse statistik – antal besøgende mv. på min gofiqr?</h2>
                <p>Statistikmodulet giver dig mange muligheder: Du kan se, hvor mange gange en kode har været scannet, på hvilke dage det er sket og også se, hvilke typer indhold dine brugere aktiverer – og på hvilke sprog. Du finder let ud af, hvilke koder og indholdstyper dine brugere og kunder godt kan lide. Og du kan se om din digitale strategi fungerer.</p>

                <h2>Hvordan kommer jeg igang?</h2>
                <p>Du skal tale med os – vi insisterer på dialog før køb – og når I så har købt løsningen, er I igang med sikre og professionelle QR-koder på få minutter.</p>

                <h2>Hvad koster det?</h2>
                <p>En komplet løsning til din organisation koster kr. 20.000 om året alt inklusive (dog eksklusive moms). Dvs. I får eget gofiqr domæne, I kan lave ubegrænset antal QR-koder, og  I kan være så mange registrerede brugere, I ønsker.</p>
                <p>Hvis I ønsker, at vi håndterer alt det tekniske, så har vi et fuld service koncept, hvor vi tager os af det hele for en årlig pris pr. gofiqr kode. Kontakt os for at diskutere mulighederne.</p>
                <p>Hvis I forventer meget aktivitet på jeres gofiqr koder eller har specielle krav til datacenter mv., så laver vi en opsætning, der passer med jeres krav.</p>

                <h2>Er der support med i prisen?</h2>
                <p>Ja, I kan tilgå vores supportløsning online og ringe til os – vi lægger stor vægt på personlig kontakt og hjælp.</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "QAndAPage"
    }
</script>

<style scoped>

</style>